module.exports = __webpack_public_path__ + "img/4506c719d6891973b8ed4fe0c49069d2.png";